<template>
  <div :key="assessment.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'assessment',
        ]),
    },
    methods: {
        ...mapActions({
            getLegionellaRiskAssessment: 'getLegionellaRiskAssessment',
        }),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.assessmentId !== to.params.assessmentId) {
            if (await this.getLegionellaRiskAssessment(to.params.assessmentId)) {
                next();
            }
        }
        next();
    },
};
</script>
